import * as AppconfigActioncreator from "./AppconfigActionCreator";

export function appconfigState() {
  return {
    // expandMenuBar: true,
    expandMenuBar: window.innerWidth >= 768,
    appLoading: false,
  };
}


export const AppConfigReducer = (state, action) => {
  if (
    !state ||
    action.type === AppconfigActioncreator.APPCONFIGACTION.RESET_TOGGLE_MENU_BAR
  ) {
    return { ...state, ...appconfigState() };
  }

  if (action.type === AppconfigActioncreator.APPCONFIGACTION.TOGGLE_MENU_BAR) {
    return { ...state, expandMenuBar: action.data };
  }

  return state;
};


export function appconSideBarHover() {
  return {
    hover: false,
    loading: false,
  }
}

export const AppConfigHoverReducer = (state, action) => {
  if (
    !state ||
    action.type === AppconfigActioncreator.APPCONFIGACTION.RESET_HOVER_MENU_BAR
  ) {
    return { ...state, ...appconSideBarHover() };
  }

  if (action.type === AppconfigActioncreator.APPCONFIGACTION.TOGGLE_HOVER_MENU_BAR) {
    return { ...state, hover: action.data };
  }

  return state;
} 